import { createContext, useContext } from "react";

export interface PageHeaderSlots {
  left: HTMLDivElement | null;
  /** Entre el espaciador y el chip de objetivo: acciones propias de la página. */
  actions: HTMLDivElement | null;
  right: HTMLDivElement | null;
}

const PageHeaderSlotContext = createContext<PageHeaderSlots>({ left: null, actions: null, right: null });

export const PageHeaderSlotProvider = PageHeaderSlotContext.Provider;

export function usePageHeaderSlots(): PageHeaderSlots {
  return useContext(PageHeaderSlotContext);
}
